import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_446: DocMigration = {
  maxSchemaVersion: "0.0.446",
  description: "Remove edgeModifiers with dangling parentId (parent does not exist as ROOM, ROOF, or RAILING)",
  apply(json: any, warnings: string[]): any {
    if (!json.edgeModifiers) {
      return json;
    }
    const newEdgeModifiers: Record<string, any> = {};
    for (const edgeModifierId in json.edgeModifiers) {
      const edgeModifier = json.edgeModifiers[edgeModifierId];
      const parentId = edgeModifier.parentId;
      if (!parentId) {
        warnings.push(`edgeModifier ${edgeModifierId} has no parentId, removing.`);
        continue;
      }
      const hasRoomParent = json.rooms?.[parentId];
      const hasRoofParent = json.roofs?.[parentId];
      const hasRailingParent = json.railings?.[parentId];
      if (hasRoomParent || hasRoofParent || hasRailingParent) {
        newEdgeModifiers[edgeModifierId] = edgeModifier;
      } else {
        warnings.push(`edgeModifier ${edgeModifierId} has dangling parentId ${parentId}, removing.`);
      }
    }
    return {
      ...json,
      edgeModifiers: newEdgeModifiers,
    };
  },
};

export default migration_0_0_446;
